module.exports = __webpack_public_path__ + "webstatic/img/img1.fd93efc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/img1.jpg
// module id = OzmS
// module chunks = 3